import React from 'react';
import { CellProps } from 'react-table';
import classNames from 'classnames';
import styles from '../assets/provider-actions.module.scss';
import { IProvider } from 'src/types/provider';
import StatusProviderAction from './StatusProviderAction';

const ProviderActionsColumn: React.FunctionComponent<CellProps<IProvider>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IProvider>) => {
    return (
        <div className={classNames(styles.actions)}>
            <StatusProviderAction data={original} />
        </div>
    );
};

export default ProviderActionsColumn;
